import AbstractException from '../AbstractException';
import ExceptionTypeEnum from '../enums/ExceptionTypeEnum';

/**
 * Custom exception.
 */
export default class Exception extends AbstractException {
	public exceptionType = ExceptionTypeEnum.generic;
	public name = 'Exception';
}
